import { Component, OnInit } from '@angular/core';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { MatDialogRef } from '@angular/material/dialog';
import { UmsService } from '../ums.service';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';

@Component({
  selector: 'app-eligibility-criteria',
  templateUrl: './eligibility-criteria.component.html',
  styleUrls: ['./eligibility-criteria.component.scss']
})
export class EligibilityCriteriaComponent implements OnInit {
  dialogRef!: MatDialogRef<any>;
  sessionList!: any[];
  SessionFilterList!: any[];
  fcCodeList: any;
  filteredListFcCode!: any[];
  EligibilityCriteriaForm: any;
  CourseList: any;
  filteredCourseList!: any[];
  collegeList!: never[];
  isdisabled = false;
  CoCode: any;
  SnNo: any;
  CoName: any;
  filteredExamAList: any;
  ExamAList: any;
  isCriteriaSaved = false;
  examList: any;
  filteredListExam: any;
  selectedEmId: number | null = null;

  constructor(
    private modalPopupService: ModalpopService,
    private umsService: UmsService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
  ) { }

  ngOnInit(): void {
    this.EligibilityCriteriaForm = this.fb.group({
      SessionID: new FormControl('', [Validators.required]),
      course: new FormControl('', [Validators.required]),
      EmId: new FormControl('', [Validators.required]),
      CoFcCode: new FormControl('', [Validators.required]),
      Elective: [false],
      Attendence: [false],
      IA_Marks: [false]
    });

    this.fetchSession();
    this.fetchFacultyCode();
  }

  fetchFacultyCode() {
    this.spinner.show()
    const payload = {};
    this.umsService.getFaculty(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide()
        this.fcCodeList = res.data;
        this.filteredListFcCode = this.fcCodeList.slice();
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }
  fetchSession() {
    const payload: {} = {};
    this.umsService.getSession(payload).subscribe(res => {
      this.sessionList = [];
      if (res.status) {
        res.data.forEach((element: any) => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data: any = {};
      this.sessionList = [];
      this.SessionFilterList = [];
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
    });

  }


  fetchCourse(id: any) {
    console.log("fetchCourse>>??", id)
    const payload: { [key: string]: any } = {};
    payload['CoCgCgCode'] = id;
    payload['SessionID'] = sessionStorage.getItem('SessId');
    this.umsService.getSessionColgCo(payload).subscribe(res => {
      if (res.status) {
        this.CourseList = res.data;
        this.filteredCourseList = this.CourseList.slice();
        console.log("fileterere", this.filteredCourseList)
        this.getExamList('');
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.CourseList = [];
      this.filteredCourseList = [];
      let data: any = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
    });
  }


  selectSessionID(id: any) {
    sessionStorage.setItem('SessionID', id);
  }

  getCriteria(event: any) {

    this.EligibilityCriteriaForm.patchValue({
      Attendence: false,
      IA_Marks: false,
      Elective: false
    });
    this.isCriteriaSaved = false;
    this.toggleCriteria(false);
    this.selectedEmId = Number(event.value);
    this.umsService.getEligibilityCriteria(this.selectedEmId).subscribe((res: any) => {
      if (res.data) {

        this.EligibilityCriteriaForm.patchValue({
          Attendence: res.data[0][0].IsAttendance,
          IA_Marks: res.data[0][0].IsIaMarks,
          Elective: res.data[0][0].IsElective
        });

        // Checkbox Disable
        this.toggleCriteria(true);
        // Save Disable
        this.isCriteriaSaved = true;

      } else {

        this.EligibilityCriteriaForm.patchValue({
          Attendence: false,
          IA_Marks: false,
          Elective: false
        });

        this.toggleCriteria(false);
        this.isCriteriaSaved = false;
      }
    })
  }


  getCourseData(id: any) {

    this.EligibilityCriteriaForm.patchValue({
    course: null,
    EmId: null,
    Attendence: false,
    IA_Marks: false,
    Elective: false
  });

  this.selectedEmId = null;

  // Lists clear karo
  this.CourseList = [];
  this.filteredCourseList = [];
  this.examList = [];
  this.filteredListExam = [];

    this.CourseList = []
    this.filteredCourseList = []
    this.spinner.show();
    const payload: any = {};
    payload['CoFcCode'] = id;
    this.umsService.getCourse(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.CourseList = res.data;
        this.filteredCourseList = this.CourseList.slice();
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data: any = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }
saveCriteria() {

  if (this.EligibilityCriteriaForm.invalid) {
    this.EligibilityCriteriaForm.markAllAsTouched();
    return;
  }

  const confirmDialog = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, {
      message: `Are you sure you want to Save the selected eligibility criteria?`,
      title: 'Confirm Save',
      icon: 'fa fa-question'
    });

  confirmDialog.afterClosed().subscribe(confirmed => {
    if (confirmed !== 'yes') return;

    const form = this.EligibilityCriteriaForm.value;
    const payload = {
      EmId: this.selectedEmId,
      Attendence: form.Attendence,
      IA_Marks: form.IA_Marks,
      Elective: form.Elective
    };
    this.spinner.show();
    this.umsService.saveCriteria(payload).subscribe(
      (res: any) => {
        this.spinner.hide();
        let data: any = {
          message: res.message,
          title: res.title
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );

        this.dialogRef.afterClosed().subscribe(() => {

          this.EligibilityCriteriaForm.reset({
            SessionID: null,
            course: null,
            EmId: null,
            CoFcCode: null,
            Elective: false,
            Attendence: false,
            IA_Marks: false
          });

          // Form state reset
          this.selectedEmId = null;
          this.isCriteriaSaved = false;
          this.toggleCriteria(false);
        });
      },
      (err: any) => {
        this.spinner.hide();
        console.log(err);
      }
    );
  });

}


  toggleCriteria(disable: boolean) {

    const controls = ['Attendence', 'IA_Marks', 'Elective'];
    controls.forEach(control => {
      if (disable) {
        this.EligibilityCriteriaForm.get(control)?.disable();
      } else {
        this.EligibilityCriteriaForm.get(control)?.enable();
      }
    });

  }

  cancelSelection() {

    // this.EligibilityCriteriaForm.patchValue({
    //   Attendence: false,
    //   IA_Marks: false,
    //   Elective: false
    // });

    // this.isCriteriaSaved = false;
    // this.toggleCriteria(false);
  }

  getExamList(CoCode: any) {
  this.EligibilityCriteriaForm.patchValue({
    EmId: null,
    Attendence: false,
    IA_Marks: false,
    Elective: false
  });

  this.selectedEmId = null;
  this.examList = [];
  this.filteredListExam = [];
    this.spinner.show();
    const payload: any = {};
    payload['EmCoCode'] = CoCode;
    this.examList = []
    this.umsService.getExam(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.examList = res.data;
        this.filteredListExam = this.examList.slice();
      }
      else {
        this.spinner.hide();
        let data: any = {}
        data['message'] = res.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data: any = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.ngOnInit();

    });
  }
}


